  import {DynaAuthRTTClient} from "dyna-auth-rtt";

export const dynaAuthRTTClient = new DynaAuthRTTClient();
export const request = dynaAuthRTTClient.request;
